import React, { PureComponent } from 'react';
import {
    ComposedChart, Line, Area, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
    Legend, ResponsiveContainer
} from 'recharts';

const data = [
    {
        name: 'Industry', lr: 0.78, rf: 0.60, nn: 0.57, average: 0.65,
    },
    {
        name: 'Equity Value', lr: 0.65, rf: 0.49, nn: 0.68, average: 0.61,
    },
    {
        name: 'Financials', lr: 0.44, rf: 0.43, nn: 0.48, average: 0.45,
    },
    {
        name: 'Age', lr: 0.41, rf: 0.39, nn: 0.40, average: 0.40,
    },
    {
        name: 'Reporting', lr: 0.29, rf: 0.21, nn: 0.26, average: 0.25,
    },
    {
        name: 'Location', lr: 0.20, rf: 0.24, nn: 0.11, average: 0.18,
    },
    {
        name: 'Directors', lr: 0.22, rf: 0.11, nn: 0.13, average: 0.15,
    },
];

export default class ModelRiskChart extends PureComponent {

    render() {
        return (
            <ResponsiveContainer width="100%" height={350}>
            <ComposedChart
                data={data}
                margin={{
                    top: 0, right: 0, bottom: 0, left: 20,
                }}
                layout='vertical'
            >
                <CartesianGrid stroke="#f5f5f5"/>
                <YAxis dataKey="name"  type="category"/>
                <XAxis type="number"/>
                <Tooltip />
                <Legend />
                <Bar dataKey="lr" barSize={20} fill="#505050"/>
                <Bar dataKey="rf" barSize={20} fill="#808080"/>
                <Bar dataKey="nn" barSize={20} fill="#A9A9A9" />
                <Line type="monotone" dataKey="average" stroke="#000000" strokeDasharray="5 3"/>
            </ComposedChart>
            </ResponsiveContainer>
        );
    }
}
